import { DotsThreeVertical, PencilSimple, Trash } from "@phosphor-icons/react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

interface ClientActionsDropdownProps {
  setAction: (newAction: "remove" | "edit") => void;
}

export default function ClientActionsDropdown({
  setAction,
}: ClientActionsDropdownProps) {
  return (
    <RestrictedComponent visibleForPermissions={["members_full"]}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button intent="iconOnly" variant="secondary-black">
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuList>
            <DropdownMenuItem
              variant="danger"
              onClick={() => setAction("edit")}
            >
              <PencilSimple />
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              variant="danger"
              onClick={() => setAction("remove")}
            >
              <Trash />
              Remove from workspace
            </DropdownMenuItem>
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>
    </RestrictedComponent>
  );
}
